import CalculateDetailContainer from './CalculateDetailContainer';
export default CalculateDetailContainer;
